import DOMPurify from 'dompurify';

export const getAdminToken = () => {
    try {
        const token = sessionStorage.getItem('admin_token');
        if (!token) return null;
        return DOMPurify.sanitize(token);
    } catch {
        return null;
    }
};

export const setAdminToken = (token) => {
    sessionStorage.setItem('admin_token', token);
};

export const removeAdminToken = () => {
    sessionStorage.removeItem('admin_token');
};